const extractExtension = (file: File) => {
    return file.name.split(".").pop();
};

export default extractExtension;
